import React, { Component } from 'react';
import { useTranslation } from "react-i18next";
import { LocalStorageService, DigitalVaultDocumentService, WorkflowService, QuestionnaireService } from '../../../services';
import { changeFormatNumberToShow, getNavigatorTimezone, parseEntities } from '../../../utils';
import { DigitalVaultFollowUpDocumentView } from '../../views';

class DigitalVaultFollowUpDocumentAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            token: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            titleView: '',
            documentData: {
                name: ''
            },
            nameBtnNext: '',
            backBtnName: '',
            entities: [],
            documentId: 0,
            statusCapture: [
                Number(process.env.REACT_APP_NEW_DOCUMENT_STATUS_300120),
                Number(process.env.REACT_APP_NEW_DOCUMENT_STATUS_300122),
                Number(process.env.REACT_APP_NEW_DOCUMENT_STATUS_300123),
                Number(process.env.REACT_APP_NEW_DOCUMENT_STATUS_300125)
            ],
            selectedFile: null,
            showDocumentGrid: false,
            showEntities: true,
            showDocumentPDF: true,
            showBasicData: false,
            showVariables: false,
            showBtnNextStatus: true,
            showBtnDataInCapture: true,
            userHasPermission: false,
            canEditName: false,
            disableElements: true,
            showBtnBackStatus: false,
            statusBackBtn: 0,
            statusNextBtn: 0,
            optionsUse: [
                {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.no.assign"),
                    value: 0
                },
                {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.alias"),
                    value: 1
                },
                {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.description"),
                    value: 2
                },
                {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.start.date"),
                    value: 3
                },
                {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.end.date"),
                    value: 4
                },
                {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.value"),
                    value: 5
                },
                {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.confidenciality"),
                    value: 6
                },
                {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.obligatory"),
                    value: 7
                },
                {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.penalty"),
                    value: 8
                },
                {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.etiquetas"),
                    value: 9
                }, {
                    name: this.props.t("digitalVaultFollowUpDocumentAction.options.new.variable"),
                    value: 10
                }
            ],
            variablesToShow: [],
            status: 0,
            entitiesRaw: {},
            monetaryUnits: [],
            files: [],
            urlSelected: '',
            fileType: "pdf"
        }
    }

    ENV = process.env
    token = {};
    user = {};
    user = {}
    id = 0
    workflowExecutionId = ''
    entitiesOptions = [
        {
            name: this.props.t("parseEntities.all.entities")
        }
    ]
    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService();
    digitalVaultDocumentService = new DigitalVaultDocumentService(process.env.REACT_APP_MIFIRMA_API)
    questionnaireService = new QuestionnaireService(this.url)
    workflowService = new WorkflowService(this.url);
    documentId = 0
    timezone = getNavigatorTimezone()

    async componentDidMount() {
        this.toggleLoadingView(true)
        this.token = this.localStorageService.getLocalStorageItem("token").idToken;
        this.user = this.localStorageService.getLocalStorageItem("user");

        const params = this.props.match.params
        this.documentId = params.id
        this.workflowExecutionId = params.workflowExecutionId
        this.getDocumentData()
        this.getMonetaryUnits()

        if (this.props.noWorkflow) {
            this.setState({
                noWorkflow: true,
                workflow: this.props.data.workflow,
                titleView: this.props.data.titleView,
                status: this.props.data.status,
                showEntities: this.props.data.showEntities,
                showDocumentPDF: this.props.data.showDocumentPDF,
                showBtnNextStatus: this.props.data.showBtnNextStatus,
                showBtnBackStatus: this.props.data.showBtnBackStatus,
                showBasicData: this.props.data.showBasicData,
                showVariables: this.props.data.showVariables,
                canEditName: this.props.data.canEditName,
                nameBtnNext: this.props.data.nameBtnNext,
                backBtnName: this.props.data.backBtnName,
                userHasPermission: this.props.data.userHasPermission,
                disableElements: this.props.data.disableElements,
                showBtnDataInCapture: this.props.data.showBtnDataInCapture,
                statusNextBtn: this.props.data.statusNextBtn,
                statusBackBtn: this.props.data.statusBackBtn,
                handleSubmitNoWorkflow: this.props.data.handleSubmitNoWorkflow
            });
        }
        this.setState({
            documentId: this.documentId,
            workflowExecutionId: this.workflowExecutionId
        })
    }

    getMonetaryUnits = async () => {
        let messageError = this.props.t("digitalVaultFollowUpDocumentAction.errors.monetary")
        try {
            let monetaryUnits = await this.questionnaireService.getAllCurrencyUnits(this.token)
            if (monetaryUnits.data.statusCode === 200 && monetaryUnits.data.data) {
                this.setState({
                    monetaryUnits: monetaryUnits.data.data,
                })
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, false, "/")
            }
        } catch (e) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoading: value
        })
    }

    toggleError = () => {
        this.setState({ showErrorRequesting: false })
    }

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo)
                    }
                }
            }, time || 4000)
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleCompletedRequesting = (time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo);
                    }
                }
            }, time || 4000)
        })
    }

    getDocumentData = async () => {
        let errorMessage = this.props.t("digitalVaultFollowUpDocumentAction.errors.data.doc")
        try {
            let documentInfo = await this.digitalVaultDocumentService.getDocumentData(this.documentId, this.timezone, this.token)
            if (documentInfo && documentInfo.data && Number(documentInfo.statusCode) === 200) {
                let variablesBD = (documentInfo.data.document && documentInfo.data.document.variables) ? documentInfo.data.document.variables : []
                let newOptions = [...this.state.optionsUse]
                variablesBD = variablesBD.map((variable) => {
                    if (variable.type && variable.type === 1) {
                        variable.valueVariable = variable.valueVariable.replaceAll(',', '')
                        variable.valueVariable = changeFormatNumberToShow(variable.valueVariable, 1)
                    }

                    if (variable.type && variable.type === 2) {
                        variable.valueVariable = (variable.valueVariable) ? new Date(variable.valueVariable) : ''
                    }

                    let varToPush = {}
                    varToPush.name = variable.variableName
                    varToPush.varId = variable.id
                    varToPush.value = newOptions.length + 1
                    newOptions.push(varToPush)
                    return variable
                })

                let files = (documentInfo.data.entities && documentInfo.data.entities.length > 0)
                    ? documentInfo.data.entities
                    : (documentInfo.data.document.files && documentInfo.data.document.files.length > 0)
                        ? documentInfo.data.document.files
                        : []

                //Parse entities
                files = files.map((file) => {
                    file.entities = file.entities || []
                    file.summary = file.summary || ''
                    let entities = parseEntities(file.entities, this.props.t)
                    entities = entities.sort((a, b) => a.type.toLowerCase().localeCompare(b.type.toLowerCase()));
                    file.entities = entities
                    return file
                })

                for (const file of files) {
                    if (file.entities && file.entities.length === 0) {
                        file.entitiesOptions = this.entitiesOptions
                        continue
                    } else {
                        const entities = [...new Set([...file.entities.map(item => item && item.type)])].map(name => ({ name }))
                        file.entitiesOptions = this.entitiesOptions.concat(entities)
                    }
                }

                let filteredFiles = Array.isArray(files) ? files.filter(file => file.name && file.name.endsWith('pdf')) : []
                let fileSelected = (filteredFiles && filteredFiles.length > 0 && filteredFiles[0]) ? filteredFiles[0] : null
                let urlSelected = (filteredFiles && filteredFiles.length > 0 && filteredFiles[0].url) ? filteredFiles[0].url : ''
                let entitiesSelected = (filteredFiles && filteredFiles.length > 0 && filteredFiles[0].entities) ? filteredFiles[0].entities : []
                let summarySelected = (filteredFiles && filteredFiles.length > 0 && filteredFiles[0].summary) ? filteredFiles[0].summary : ''
                let fileType = (filteredFiles && filteredFiles.length > 0 && filteredFiles[0].fileType) ? filteredFiles[0].fileType : 'pdf'
                if (Array.isArray(filteredFiles) && filteredFiles.length > 0 && Array.isArray(filteredFiles[0].entitiesOptions) && filteredFiles[0].entitiesOptions.length > 0)
                    this.entitiesOptions = filteredFiles[0].entitiesOptions

                let entitiesRaw = entitiesSelected
                const documentWithFiles = {
                    ...documentInfo.data.document,
                    files
                }

                this.setState({
                    documentData: documentWithFiles,
                    showDocumentGrid: documentInfo.data.document.infoType === 'Expediente' && files.length > 1,
                    entities: entitiesSelected,
                    selectedFile: fileSelected,
                    summary: summarySelected,
                    optionsToUse: newOptions,
                    variablesToShow: variablesBD,
                    entitiesRaw,
                    files,
                    urlSelected,
                    fileType
                })
                if (this.props.noWorkflow) {
                    this.toggleLoadingView(false)
                    return
                }
                await this.getWorkExecutionId();
                this.toggleLoadingView(false)
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(errorMessage, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(errorMessage, 4000, false)
        }
    }

    async getWorkExecutionId() {
        let errorMessage = this.props.t("digitalVaultFollowUpDocumentAction.errors.workflow")
        const userWithoutEditPermission = this.state.documentData.permissions.find(permission => !permission.permissions.editMetadata && permission.userId == this.user.userMetaData.userMifirma.id)
        if (!this.workflowExecutionId) {
            this.setState({
                titleView: this.props.t("digitalVaultFollowUpDocumentAction.title.edit"),
                canEditName: true,
                showEntities: false,
                showDocumentPDF: true,
                showBtnNextStatus: true,
                showBtnBackStatus: false,
                showBasicData: true,
                showVariables: true,
                nameBtnNext: this.props.t("button.save"),
                userHasPermission: true,
                disableElements: false,
                showBtnDataInCapture: false
            });
            return;
        }
        try {
            let workflowExecution = await this.workflowService.getWorkFlowExecutionById(this.workflowExecutionId, this.token);
            if (workflowExecution && workflowExecution.data && Number(workflowExecution.statusCode) === 200) {
                let statusCurrent = workflowExecution.data.workflowStatusDescriptions.statusCurrent.status;
                let currenteName = workflowExecution.data.workflowStatusDescriptions.statusCurrent.name;
                let titleHeader = (currenteName) ? `${this.props.t("digitalVaultFollowUpDocumentAction.title.new.document")} / ${currenteName}` : ''
                let statusIsEnableInCapture = this.state.statusCapture.includes(statusCurrent)
                let nameBtn = (workflowExecution.data.workflowStatusDescriptions && workflowExecution.data.workflowStatusDescriptions.statusNext && workflowExecution.data.workflowStatusDescriptions.statusNext.name) ? workflowExecution.data.workflowStatusDescriptions.statusNext.name : 'Validar documento'
                let nameBackBtn = (workflowExecution.data.workflowStatusDescriptions && workflowExecution.data.workflowStatusDescriptions.statusBack && workflowExecution.data.workflowStatusDescriptions.statusBack.name) ? workflowExecution.data.workflowStatusDescriptions.statusBack.name : 'Regresar'
                let showBtnDataInCapture = (statusIsEnableInCapture) ? true : false

                //verify if user has permission
                let rolesMember = workflowExecution.data.workflowExecutionMembers.filter((member) => member.email === this.user.userMetaData.userA3Cloud.email)
                let userPermissionWorkflowArr = JSON.parse(workflowExecution.data.workflowStatus.membersTypeAllowToShow)
                let allPermission = rolesMember.map(role => {
                    let permissionUser = userPermissionWorkflowArr.includes(role.workflowExecutionMemberTypeId)
                    return permissionUser
                })

                let userHasPermission = allPermission.includes(true) ? true : false
                let statusNextBtn = workflowExecution.data.workflowStatusDescriptions.statusNext.status
                let statusBackBtn = workflowExecution.data.workflowStatusDescriptions.statusBack.status
                let showBtnNextStatus = (!statusIsEnableInCapture || (statusIsEnableInCapture && showBtnDataInCapture) || !userHasPermission || statusNextBtn <= 0) ? false : true
                let showBtnBackStatus = (!statusIsEnableInCapture || (statusIsEnableInCapture && showBtnDataInCapture) || !userHasPermission || statusBackBtn <= 0) ? false : true
                let disableElements = (!statusIsEnableInCapture || !userHasPermission) ? true : false

                const documentIsValidated = statusCurrent === Number(process.env.REACT_APP_NEW_DOCUMENT_STATUS_300130)
                if (documentIsValidated) {
                    titleHeader = this.props.t("digitalVaultFollowUpDocumentAction.title.edit")
                    userHasPermission = true
                    nameBtn = this.props.t("button.save")
                    showBtnNextStatus = true
                    showBtnBackStatus = false
                    disableElements = false
                }

                this.setState({
                    workflow: workflowExecution.data,
                    titleView: titleHeader,
                    status: statusCurrent,
                    showEntities: statusIsEnableInCapture,
                    showDocumentPDF: documentIsValidated || statusIsEnableInCapture,
                    showBtnNextStatus: showBtnNextStatus,
                    showBtnBackStatus: showBtnBackStatus,
                    showBasicData: documentIsValidated,
                    showVariables: documentIsValidated,
                    canEditName: documentIsValidated,
                    nameBtnNext: nameBtn,
                    backBtnName: nameBackBtn,
                    userHasPermission,
                    disableElements,
                    showBtnDataInCapture,
                    statusNextBtn,
                    statusBackBtn
                });
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(errorMessage, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(errorMessage, 4000, false)
        }
    }

    handleSaveData = async (alias, description, startDate, validation, amount, confidential, notify, mandatory, penalty, tags, entities, variables, name, categoryId, companyId, pathBreadcrumb, workflowEXP, monetaryUnit, typeDocument, sendFilesToOCR, dataFilesToOCR, sendFilesToOCRValue) => {
        this.toggleLoadingRequesting(true)
        let errorMessage = this.props.t("digitalVaultFollowUpDocumentAction.errors.save.data")
        try {
            const doc = this.state.documentData || {}
            const fallbackPath = pathBreadcrumb || doc.pathBreadcrumb || ''
            let normalizedCategoryId = categoryId
            if (normalizedCategoryId === null || normalizedCategoryId === undefined) {
                if (typeof fallbackPath === 'string' && fallbackPath.length > 0) {
                    const parts = fallbackPath.split('/').filter(Boolean)
                    normalizedCategoryId = parts.length ? Number(parts[parts.length - 1]) : null
                } else {
                    normalizedCategoryId = null
                }
            }

            const normalizedCompanyId = companyId || doc.companyId || null
            const normalizedPath = (typeof fallbackPath === 'string') ? fallbackPath : ''
            const normalizedVariables = Array.isArray(variables) ? variables : []
            const normalizedTags = Array.isArray(tags) ? tags : []
            const normalizedEntities = entities && typeof entities === 'object' ? entities : { values: [] }

            const normalizedDataFilesToOCR = Array.isArray(dataFilesToOCR) ? dataFilesToOCR : []

            let updateDocument = await this.digitalVaultDocumentService.updateDocumentVault(
                this.documentId,
                alias,
                description,
                startDate,
                validation,
                amount,
                confidential,
                notify,
                mandatory,
                penalty,
                normalizedTags,
                normalizedEntities,
                this.workflowExecutionId,
                normalizedVariables,
                this.token,
                name,
                normalizedCategoryId,
                normalizedCompanyId,
                normalizedPath,
                workflowEXP,
                monetaryUnit,
                typeDocument,
                sendFilesToOCR,
                normalizedDataFilesToOCR,
                sendFilesToOCRValue
            )
            if (updateDocument && updateDocument.data && Number(updateDocument.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, true, '/digital-vault/home')
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(errorMessage, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(errorMessage, 4000, false)
        }
    }

    handleCancel = async () => {
        if (this.state.workflow && this.workflowExecutionId && this.state.documentData.infoType === 'Documento') {
            let statusCurrent = (this.state.workflow.workflowStatusDescriptions && this.state.workflow.workflowStatusDescriptions.statusCurrent && this.state.workflow.workflowStatusDescriptions.statusCurrent.status) ? this.state.workflow.workflowStatusDescriptions.statusCurrent.status : 0
            if (this.state.statusCapture.includes(statusCurrent) && this.state.showDocumentPDF === false) {
                this.setState({
                    showDocumentPDF: true,
                    showBasicData: false,
                    showVariables: false,
                    showBtnDataInCapture: true,
                    showBtnNextStatus: false,
                    showBtnBackStatus: false
                })

                return
            }
        }

        const locationState = this.props.location.state
        if (locationState && locationState.from) {
            this.props.history.push({
                pathname: locationState.from,
                state: locationState
            })
        } else {
            this.props.history.push("/")
        }
    }

    handleFillInData = async () => {
        this.setState({
            showDocumentPDF: false,
            showBasicData: true,
            showVariables: true,
            showBtnDataInCapture: false,
            showBtnNextStatus: (this.state.userHasPermission && this.state.statusNextBtn > 0) ? true : false,
            showBtnBackStatus: (this.state.userHasPermission && this.state.statusBackBtn > 0) ? true : false
        })
    }

    handleBack = async () => {
        this.toggleLoadingRequesting(true)
        let errorMessage = this.props.t("digitalVaultFollowUpDocumentAction.errors.back.doc")
        try {
            let workflow = await this.workflowService.changeBackStatusRegistrationDocument(this.workflowExecutionId, this.documentId, this.token)
            if (workflow && workflow.data && Number(workflow.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, true, '/')
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(errorMessage, 4000, false)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(errorMessage, 4000, false)
        }
    }

    setSelectedFile = (selectedFile) => {
        let urlSelected = (selectedFile && selectedFile.url) ? selectedFile.url : this.state.urlSelected
        let fileType = (selectedFile && selectedFile.fileType) ? selectedFile.fileType : "pdf"
        this.setState({
            selectedFile,
            urlSelected,
            fileType
        })
    }

    handleSelectFile = (file) => {
        let fileSelected = this.state.files.find(fileState => fileState.id === file.id)
        let urlSelected = (fileSelected && fileSelected.url) ? fileSelected.url : ''
        let entitiesSelected = (fileSelected && fileSelected.entities) ? fileSelected.entities : []
        let summarySelected = (fileSelected && fileSelected.summary) ? fileSelected.summary : ''
        let fileType = (fileSelected && fileSelected.fileType) ? fileSelected.fileType : 'pdf'
        this.entitiesOptions = file && file.entitiesOptions && file.entitiesOptions.length > 0 ? file.entitiesOptions : this.entitiesOptions

        this.setState({
            urlSelected,
            entities: entitiesSelected,
            summary: summarySelected,
            fileType
        })
    }

    render() {
        return (
            <DigitalVaultFollowUpDocumentView
                {...this.props}
                {...this.state}
                entitiesOptions={this.entitiesOptions}
                toggleError={this.toggleError}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                handleSaveData={this.handleSaveData}
                handleCancel={this.handleCancel}
                handleFillInData={this.handleFillInData}
                handleBack={this.handleBack}
                setSelectedFile={this.setSelectedFile}
                handleSelectFile={this.handleSelectFile}
            />
        )
    }
}


function DigitalVaultFollowUpDocumentActionContainer(props) {
    const { t } = useTranslation();

    return (
        <DigitalVaultFollowUpDocumentAction
            {...props}
            t={t}
        />
    )
}

export { DigitalVaultFollowUpDocumentActionContainer as default }
